// Generated by Melange

import * as Buhta_cabinet__IdentityApiPage from "./IdentityApiPage.js";
import * as Buhta_cabinet__IdentityGeneralPage from "./IdentityGeneralPage.js";
import * as Buhta_cabinet__IdentitySecurityPage from "./IdentitySecurityPage.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(route) {
  return function (openMenu) {
    switch (route) {
      case /* General */0 :
          return JsxRuntime.jsx(Buhta_cabinet__IdentityGeneralPage.make, {
                      openMenu: openMenu
                    });
      case /* Security */1 :
          return JsxRuntime.jsx(Buhta_cabinet__IdentitySecurityPage.make, {
                      openMenu: openMenu
                    });
      case /* API */2 :
          return JsxRuntime.jsx(Buhta_cabinet__IdentityApiPage.make, {
                      openMenu: openMenu
                    });
      
    }
  };
}

function IdentityViewPage(Props) {
  return make(Props.route)(Props.openMenu);
}

const make$1 = IdentityViewPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__IdentityApiPage Not a pure module */
